/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './helperSearch.module.scss';
import isFunction from 'lodash-es/isFunction';
import cx from 'classnames';
import { useSearchControl } from 'hooks/useSearchControl';
import SearchInput from '../core/searchInput/searchInput';
import SearchOverlay from '../core/searchOverlay/searchOverlay';
import SearchDropdown from '../core/searchDropdown/searchDropdown';
import SearchDublication from '../core/searchDublication/searchDublication';
import SearchInputContainer from '../core/searchLineContainer/searchLineContainer';
import { useUniqueKeyHandler } from 'hooks/useKeyHandler';

export type SearchSection = 'selected' | 'available' | 'create' | 'top';

export type SpecialChipType = 'only_uploaded' | 'only_liked';

export default function HelperSearch({
  sectionsOrder = ['selected', 'available', 'create', 'top'],
  isDisabled = false,
  className = '',
  tagsStrategy,
  initialSearch = '',
  overrideSectionTexts,
  inputIcon,
}: {
  isDisabled?: boolean;
  className?: string;
  tagsStrategy?: typeof useSearchControl; // search это по сути только контейнер, логику можно конфигурировать из вне
  initialSearch?: string; // Начальное значение в строке поиска
  sectionsOrder?: SearchSection[]; // Можно переопределить порядок и наличие секций из вне
  overrideSectionTexts?: { [x: string]: string };
  inputIcon?: React.ReactNode;
}) {
  const {
    selected,
    available,
    getChip,
    clearAll,
    search,
    setSearch,
    availableHash,
    top,
  } = isFunction(tagsStrategy) ? tagsStrategy() : useSearchControl();

  const [isOpen, setIsOpen] = useState(false);
  const keyHandlerId = useUniqueKeyHandler();

  useEffect(() => {
    if (initialSearch) {
      setSearch(initialSearch);
    }
  }, [initialSearch]);

  return (
    <>
      <div
        className={cx(
          'searchControlHelper',
          style.container,
          className,
          isDisabled ? 'disabled' : '',
          isOpen ? 'isOpen' : ''
        )}
      >
        <SearchOverlay isOpen={isOpen} setIsOpen={setIsOpen}></SearchOverlay>

        <SearchInputContainer isOpen={isOpen}>
          <SearchInput
            setIsOpen={setIsOpen}
            isDisabled={isDisabled}
            setSearch={setSearch}
            search={search}
          ></SearchInput>
          {inputIcon ? inputIcon : ''}
        </SearchInputContainer>

        {/* Выпадашка */}
        <SearchDropdown
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          sectionsOrder={sectionsOrder}
          selected={selected}
          available={available}
          overrideSectionTexts={overrideSectionTexts}
          getChip={getChip}
          search={search}
          availableHash={availableHash}
          top={top}
          hideEmptyAvailable={true}
          keyHandlerId={keyHandlerId}
        ></SearchDropdown>
      </div>

      <SearchDublication
        selected={selected}
        getChip={getChip}
        clearAll={clearAll}
      ></SearchDublication>
    </>
  );
}
